<template>
    <FKBreadCrumb :page="$t('page.consents')" />
    <ConsentsList />
</template>
  
<script lang="ts">
import { defineComponent } from "vue";

import ConsentsList from "@/components/FK/Consents/ConsentsList.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";

export default defineComponent({
    name: "ConsentsPage",
    components: {
        FKBreadCrumb,
        ConsentsList,
    },
});
</script>